import React from 'react';

type BadgeVariant = 'green' | 'red' | 'purple' | 'amber';

interface BadgeProps {
  variant: BadgeVariant;
  children: React.ReactNode;
}

/** Preset badge using CSS variable palette */
const Badge: React.FC<BadgeProps> = ({ variant, children }) => (
  <span
    className="inline-flex px-2 py-1 text-xs font-semibold rounded-full"
    style={{
      background: `var(--badge-${variant}-bg)`,
      color: `var(--badge-${variant}-text)`,
    }}
  >
    {children}
  </span>
);

export default Badge;
